import React, { useState } from 'react';
import './ConsentPopup.css';

function ConsentPopup({ termsText, username, companyName, onAccept, onClose, isLoading }) {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className="consent-overlay">
      <div className="consent-popup">
        <div className="consent-header">
          <h2 className="consent-title">Terms and Conditions</h2>
          <button
            className="consent-close-button"
            onClick={onClose}
            disabled={isLoading}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        
        <div className="consent-content">
          <div className="consent-text">
            {termsText.split('\n').map((line, index) => {
              // Skip empty lines or render them as breaks
              if (line.trim() === '') {
                return <br key={index} />;
              }
              return <p key={index}>{line}</p>;
            })}
          </div>
          
          <div className="consent-checkbox-container">
            <label className="consent-checkbox-label">
              <input
                type="checkbox"
                className="consent-checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                disabled={isLoading}
              />
              <span className="consent-checkbox-text">I have read and agree to the Terms and Conditions</span>
            </label>
          </div>
        </div>
        
        <div className="consent-footer">
          <button
            className="consent-button consent-button-accept"
            onClick={onAccept}
            disabled={isLoading || !isChecked}
          >
            {isLoading ? 'Processing...' : 'I Accept'}
          </button>
          <button
            className="consent-button consent-button-close"
            onClick={onClose}
            disabled={isLoading}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConsentPopup;

